import { FC, memo, useMemo } from "react"
import { useModals } from "@/modals"
import { useGame } from "@/providers/GameProvider"
import { useAppSelector } from "@/store"
import { AppSelectors } from "@/store/slices/app"
import { EffectFrame } from "@/ui/EffectFrame"
import { IActiveEffectsProps, LineLengthList } from "."
import styles from "./ActiveEffects.module.scss"
import { getEffectIndex } from "./helpers"

const ActiveEffectsComponent: FC<IActiveEffectsProps> = ({ playerId }) => {
  const { openModal } = useModals()
  const { getActiveEffectsByPlayerId } = useGame()

  const screen = useAppSelector(AppSelectors.selectScreen())

  const normalizedPlayerId = playerId ?? ""
  const effects = getActiveEffectsByPlayerId(normalizedPlayerId)

  const lineCount = useMemo(() => {
    const effectsCount = effects.length
    let lines = 0
    let placed = 0

    do {
      placed += LineLengthList[lines % LineLengthList.length]
      lines++
    } while (placed < effectsCount)

    return Math.max(lines, screen.height > 600 ? 2 : 1)
  }, [effects, screen.height])

  const handleOpenModal = () => {
    openModal("matchEffects", { playerId: normalizedPlayerId })
  }

  return (
    <div className={styles.ActiveEffects} onClick={handleOpenModal}>
      {Array(lineCount)
        .fill(0)
        .map((_, i) => (
          <div className={styles.ActiveEffects_line} key={i}>
            {Array(LineLengthList[i % LineLengthList.length])
              .fill(0)
              .map((_, idx) => {
                const effect = effects?.[getEffectIndex(i, idx)]

                return (
                  <EffectFrame
                    effect={effect}
                    isActiveEffect={true}
                    key={`${i}-${idx}`}
                  />
                )
              })}
          </div>
        ))}
    </div>
  )
}

export const ActiveEffects = memo(ActiveEffectsComponent)
